export const deleteScheduleApi = ( apiInstance: API.Client ) => async (uid: string) => {
  return apiInstance.Entity.collection( 'schedule' ).delete(uid);
};
